import { render, staticRenderFns } from "./CommonArrow.vue?vue&type=template&id=16260a9e&scoped=true"
import script from "./CommonArrow.vue?vue&type=script&lang=ts"
export * from "./CommonArrow.vue?vue&type=script&lang=ts"
import style0 from "./CommonArrow.vue?vue&type=style&index=0&id=16260a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16260a9e",
  null
  
)

export default component.exports